import { FirstGameStep, GameConfiguration } from '../types';

export function getActiveFirstGameSteps(
  config: GameConfiguration
): FirstGameStep[] {
  const mistsCoop =
    config.enabledModuleIds.includes('mists-over-carcassonne') &&
    config.mistsPlayMode === 'coop';
  if (mistsCoop) {
    return carcassonneFirstGameSteps.filter((s) =>
      s.requiredModuleIds?.includes('mists-over-carcassonne')
    );
  }
  return carcassonneFirstGameSteps.filter(
    (s) => !s.requiredModuleIds?.includes('mists-over-carcassonne')
  );
}

export const carcassonneFirstGameSteps: FirstGameStep[] = [
  {
    "id": "fg-01",
    "title": "Lekka konfiguracja",
    "content": [
      "Włącz bazę, Rzekę i Opata.",
      "Wyłącz wszystkie duże rozszerzenia i minidodatki.",
      "Ustaw 2–4 graczy."
    ],
    "why": "Pierwsza partia ma uczyć fundamentów.",
    "commonMistake": "Za dużo dodatków naraz.",
    "sectionId": "edition-profile",
    "checklist": [
      "Włącz bazę, Rzekę i Opata.",
      "Wyłącz wszystkie duże rozszerzenia i minidodatki."
    ]
  },
  {
    "id": "fg-02",
    "title": "Kolory i tor punktów",
    "content": [
      "Wybierzcie kolory.",
      "Jeden meeple na 0.",
      "Reszta do zasobu (+ opat)."
    ],
    "why": "Tor punktacji jest wspólny.",
    "commonMistake": "Liczenie opata jako zwykłego meepla na torze.",
    "sectionId": "setup-base",
    "checklist": [
      "Wybierzcie kolory.",
      "Jeden meeple na 0."
    ]
  },
  {
    "id": "fg-03",
    "title": "Źródło Rzeki",
    "content": [
      "Połóż źródło na środku.",
      "Oddziel jezioro.",
      "Potasuj pozostałe kafelki Rzeki."
    ],
    "why": "Rzeka zastępuje start.",
    "commonMistake": "Pomieszanie Rzeki z bazą.",
    "sectionId": "river-setup",
    "checklist": [
      "Połóż źródło na środku.",
      "Oddziel jezioro."
    ]
  },
  {
    "id": "fg-04",
    "title": "Trzy rodzaje krawędzi",
    "content": [
      "Pokaż drogę, miasto i pole.",
      "Wyjaśnij dopasowanie bokiem."
    ],
    "why": "Bez tego błędy legalności.",
    "commonMistake": "Styk tylko narożnikiem.",
    "sectionId": "tile-legality",
    "checklist": [
      "Pokaż drogę, miasto i pole.",
      "Wyjaśnij dopasowanie bokiem."
    ]
  },
  {
    "id": "fg-05",
    "title": "Pierwszy kafelek Rzeki",
    "content": [
      "Pierwszy gracz dokłada prosty odcinek.",
      "Sprawdź krawędzie."
    ],
    "why": "Ćwiczenie legalności.",
    "commonMistake": "Zakręt w złą stronę.",
    "sectionId": "river-rules",
    "checklist": [
      "Pierwszy gracz dokłada prosty odcinek.",
      "Sprawdź krawędzie."
    ]
  },
  {
    "id": "fg-06",
    "title": "Rzeka ≠ droga",
    "content": [
      "Powiedz wprost: nie stawiaj na wodzie.",
      "Pokaż lądowy element do meepla."
    ],
    "why": "Najczęstszy błąd nowicjuszy.",
    "commonMistake": "Podróżnik na wodzie.",
    "sectionId": "river-rules",
    "checklist": [
      "Powiedz wprost: nie stawiaj na wodzie.",
      "Pokaż lądowy element do meepla."
    ]
  },
  {
    "id": "fg-07",
    "title": "Zakończenie Rzeki",
    "content": [
      "Dokładajcie do jeziora.",
      "Nie podwójny zakręt w tę samą stronę."
    ],
    "why": "Rzeka musi dać się domknąć.",
    "commonMistake": "Jezioro w środku.",
    "sectionId": "river-setup",
    "checklist": [
      "Dokładajcie do jeziora.",
      "Nie podwójny zakręt w tę samą stronę."
    ]
  },
  {
    "id": "fg-08",
    "title": "Pierwszy zwykły kafelek",
    "content": [
      "Dobierz ze stosu podstawy.",
      "Dołóż bokiem."
    ],
    "why": "Start normalnej gry.",
    "commonMistake": "Dobieranie dalej z Rzeki.",
    "sectionId": "turn-structure",
    "checklist": [
      "Dobierz ze stosu podstawy.",
      "Dołóż bokiem."
    ]
  },
  {
    "id": "fg-09",
    "title": "Droga do drogi",
    "content": [
      "Ćwicz dopasowanie drogi.",
      "Obróć kafelek jeśli trzeba."
    ],
    "why": "Podstawa legalności.",
    "commonMistake": "Ignorowanie jednego sąsiada.",
    "sectionId": "tile-legality",
    "checklist": [
      "Ćwicz dopasowanie drogi.",
      "Obróć kafelek jeśli trzeba."
    ]
  },
  {
    "id": "fg-10",
    "title": "Miasto do miasta",
    "content": [
      "Ćwicz dopasowanie murów."
    ],
    "why": "Miasta rosną szybciej niż myślisz.",
    "commonMistake": "Łączenie niepołączonych grafiką segmentów.",
    "sectionId": "cities",
    "checklist": [
      "Ćwicz dopasowanie murów."
    ]
  },
  {
    "id": "fg-11",
    "title": "Nielegalne dopasowanie",
    "content": [
      "Pokaż przykład drogi do pola.",
      "Odrzuć taki ruch."
    ],
    "why": "Uczy kontroli.",
    "commonMistake": "„Prawie pasuje”.",
    "sectionId": "tile-legality",
    "checklist": [
      "Pokaż przykład drogi do pola.",
      "Odrzuć taki ruch."
    ]
  },
  {
    "id": "fg-12",
    "title": "Legalny rycerz",
    "content": [
      "Postaw rycerza w pustym mieście."
    ],
    "why": "Wejście tylko na wolny obszar.",
    "commonMistake": "Wejście do zajętego.",
    "sectionId": "meeple-placement",
    "checklist": [
      "Postaw rycerza w pustym mieście."
    ]
  },
  {
    "id": "fg-13",
    "title": "Nielegalne wejście",
    "content": [
      "Spróbuj wejść do tego samego miasta — zabronione."
    ],
    "why": "Utrwala regułę zajęcia.",
    "commonMistake": "Omijanie reguły „od drugiej strony”.",
    "sectionId": "meeple-placement",
    "checklist": [
      "Spróbuj wejść do tego samego miasta — zabronione."
    ]
  },
  {
    "id": "fg-14",
    "title": "Połączenie obszarów",
    "content": [
      "Połącz dwa zajęte obszary.",
      "Obie figury zostają."
    ],
    "why": "Uczy remisów i walki o większość.",
    "commonMistake": "Usuwanie „nadmiarowego” meepla.",
    "sectionId": "majority-ties",
    "checklist": [
      "Połącz dwa zajęte obszary.",
      "Obie figury zostają."
    ]
  },
  {
    "id": "fg-15",
    "title": "Ukończ drogę",
    "content": [
      "Zamknij drogę i daj 1/kafelek.",
      "Odzyskaj meepla."
    ],
    "why": "Pierwszy scoring w trakcie.",
    "commonMistake": "Zapominanie odzyskać meepla.",
    "sectionId": "roads",
    "checklist": [
      "Zamknij drogę i daj 1/kafelek.",
      "Odzyskaj meepla."
    ]
  },
  {
    "id": "fg-16",
    "title": "Ukończ małe miasto",
    "content": [
      "Zamknij 2 kafelki: 4 punkty (+herby)."
    ],
    "why": "Wzorzec scoringu miasta.",
    "commonMistake": "Liczenie jak na końcu gry.",
    "sectionId": "cities",
    "checklist": [
      "Zamknij 2 kafelki: 4 punkty (+herby)."
    ]
  },
  {
    "id": "fg-17",
    "title": "Klasztor i opat",
    "content": [
      "Mnich w klasztorze.",
      "Opat w ogrodzie.",
      "Później wycofaj opata zamiast stawiania."
    ],
    "why": "Opat uczy elastyczności.",
    "commonMistake": "Wycofanie + stawianie naraz.",
    "sectionId": "abbot-recall",
    "checklist": [
      "Mnich w klasztorze.",
      "Opat w ogrodzie."
    ]
  },
  {
    "id": "fg-18",
    "title": "Pola na później",
    "content": [
      "Połóż chłopa.",
      "Powiedz: punkty tylko na końcu."
    ],
    "why": "Unika wczesnego chaosu.",
    "commonMistake": "Punktowanie pola od razu.",
    "sectionId": "fields",
    "checklist": [
      "Połóż chłopa.",
      "Powiedz: punkty tylko na końcu."
    ]
  },
  {
    "id": "fg-19",
    "title": "Koniec przykładowej partii",
    "content": [
      "Dobijcie do pustego stosu lub umówcie skrót.",
      "Dokończcie ostatnią turę."
    ],
    "why": "Uczy domknięcia.",
    "commonMistake": "Punktacja w trakcie ostatniej tury.",
    "sectionId": "game-end",
    "checklist": [
      "Dobijcie do pustego stosu lub umówcie skrót.",
      "Dokończcie ostatnią turę."
    ]
  },
  {
    "id": "fg-20",
    "title": "Punktowanie końcowe",
    "content": [
      "Drogi i miasta nieukończone.",
      "Klasztory/ogrody.",
      "Pola i remisy.",
      "Wskaż zwycięzcę."
    ],
    "why": "Domknięcie nauki.",
    "commonMistake": "Pominięcie pól.",
    "sectionId": "end-scoring",
    "checklist": [
      "Drogi i miasta nieukończone.",
      "Klasztory/ogrody."
    ]
  },
  {
    id: 'fg-mists-01',
    title: 'Mgła — wybór poziomu 1',
    content: [
      'Włącz moduł Mgła nad Carcassonne.',
      'Ustaw tryb kooperacyjny (nie dodatek klasyczny).',
      'Zacznijcie od poziomu 1 (50 punktów).',
    ],
    why: 'Poziom 1 uczy mgły i duchów bez zamków i cmentarzy.',
    commonMistake: 'Start od poziomu 5 albo mieszanie z trybem klasycznym.',
    sectionId: 'mists-setup-l1',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: [
      'Tryb kooperacyjny.',
      'Poziom 1.',
    ],
  },
  {
    id: 'fg-mists-02',
    title: 'Mgła — przygotowanie stołu',
    content: [
      'Kafelek startowy na środku; 3 duchy na jego symbolach.',
      'Bez zamków i cmentarzy w poziomie 1.',
      '15 duchów w zapasie; wspólny znacznik na 0/50; cel na 50.',
      'Po 5 meepli na gracza (lub wariant 2os./solo).',
    ],
    why: 'Błędny setup psuje warunki przegranej.',
    commonMistake: 'Zostawienie zamków w stosie poziomu 1.',
    sectionId: 'mists-setup-l1',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: ['Start + 3 duchy', '15 duchów w zapasie'],
  },
  {
    id: 'fg-mists-03',
    title: 'Mgła — pierwsza tura',
    content: [
      'Dobierzcie kafelek wspólnie i dołóżcie ignorując mgłę przy dopasowaniu.',
      'Sprawdźcie zamknięcie mgły.',
      'Wystawcie duchy ( −1 przy rozszerzeniu mgły ).',
      'Opcjonalnie meeple na drodze/mieście — nigdy na polu.',
    ],
    why: 'Kolejność 1a–2b jest obowiązkowa.',
    commonMistake: 'Stawianie farmera na łące.',
    sectionId: 'mists-turn-order',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: ['Ignoruj mgłę przy krawędziach', 'Bez farmerów'],
  },
  {
    id: 'fg-mists-04',
    title: 'Mgła — pierwsze punktowanie',
    content: [
      'Ukończcie krótką drogę lub małe miasto.',
      'Wybierzcie: punkty ALBO usunięcie do 3 duchów z jednego kafelka.',
      'Przy dwóch kolorach na obiekcie doliczcie joint scoring.',
    ],
    why: 'Wybór punktów vs duchy jest kluczową decyzją kooperacji.',
    commonMistake: 'Branie punktów i usuwanie duchów naraz.',
    sectionId: 'mists-scoring-choice',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: ['Jeden wybór na punktowanie'],
  },
  {
    id: 'fg-mists-05',
    title: 'Mgła — typowe błędy',
    content: [
      'Nie zamykajcie obszaru mgły, który styka się z czystym polem w sposób uniemożliwiający domknięcie — duchy zostaną.',
      'Pilnujcie zapasu duchów: brak przy wystawieniu = przegrana.',
      'Pokazujcie kafelki i planujcie jako drużyna.',
    ],
    why: 'Przegrana często wynika z przeoczenia duchów, nie z punktacji.',
    commonMistake: 'Ukrywanie dobranego kafelka przed partnerami.',
    sectionId: 'mists-fog-ghosts',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: ['Widoczność kafelków', 'Kontrola zapasu duchów'],
  },
  {
    id: 'fg-mists-06',
    title: 'Mgła — zwycięstwo i przegrana',
    content: [
      'Zwycięstwo: znacznik na/celem 50 pkt (poziom 1).',
      'Przegrana: brak kafelków przed celem albo brak duchów do wystawienia.',
      'Bez punktowania końcowego pól.',
    ],
    why: 'Domknięcie pierwszej partii Mgły.',
    commonMistake: 'Punktowanie farmerów jak w klasycznym Carcassonne.',
    sectionId: 'mists-end-l1',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    checklist: ['Cel 50', 'Warunki przegranej'],
  },
];
